import { render, staticRenderFns } from "./InfiniteButton.vue?vue&type=template&id=177f3756"
import script from "./InfiniteButton.vue?vue&type=script&lang=js"
export * from "./InfiniteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports